export enum RoutePathType {
  SHORTEST = 'shortest',
  LONGEST = 'longest',
}
